export const LOAD = "ALERTS_LOAD";
export const LOAD_SUCCESS = "ALERTS_LOAD_SUCCESS";
export const LOAD_STATS = "ALERTS_LOAD_STATS";
export const LOAD_STATS_SUCCESS = "ALERTS_LOAD_STATS_SUCCESS";
export const MARK_ALL_AS_READ = "ALERTS_MARK_ALL_AS_READ";
export const MARK_ONE_AS_READ = "ALERTS_MARK_ONE_AS_READ";
